'use es6';

import createBatchedReferenceResolver from 'reference-resolvers/lib/createBatchedReferenceResolver';
import * as CacheKeys from 'reference-resolvers/constants/CacheKeys';
import { getPlacementById, createGetPlacementById } from 'reference-resolvers/api/CtaToPlacementAPI';
export const createCtaToPlacementReferenceResolver = options => createBatchedReferenceResolver(Object.assign({
  cacheKey: CacheKeys.CTA_TO_PLACEMENT,
  createFetchByIds: createGetPlacementById,
  fetchByIds: getPlacementById
}, options));
export default createCtaToPlacementReferenceResolver();